<template>
  <div style="width: 100px;">
    <div
      v-if="ChannelsName"
      :class="!linkActive ? 'product-name text-wrap' : 'btn-link product-name text-wrap pointer'"
    >
      <span
          v-tooltip:top="ChannelsName"
          :data-original-title="ChannelsName"
        >
          <div v-if="ChannelsName.length > 14">
            {{ ChannelsName.substr(0, 14) }}...
          </div>
          <div v-else>
            {{ ChannelsName }}
          </div>
        </span>
    </div>

  </div>
</template>
<script>

export default {
  props: {
    ChannelsName:{
      type: [String],
      default: undefined
    },
    onClickData: {
      type: [Object],
      default: null
    },
    dataTarget: {
      type: [String],
      default: null
    },
    methodsNameOnClick: {
      type: [String],
      default: null
    },
    linkActive: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
  },
  methods: {
    getActionClick(){
      if(this.methodsNameOnClick == 'onActionClicked'){
        this.$parent.$parent.onActionClicked(this.onClickData.action, this.onClickData.data, this.onClickData.id);
        return;
      }
    }

  }

}
</script>
<style scoped>
.btn-link.product-name:hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/center/ChannelsNameComponent.vue